function updatePadding() {
    requestAnimationFrame(() => {
        document.querySelectorAll(".image-container").forEach(container => {
            const img = container.querySelector("img");
            if (!img) return;

            if (img.complete && img.naturalWidth && img.naturalHeight) {
                adjustPadding(container, img);
            } else {
                img.onload = () => adjustPadding(container, img);
            }
        });
    });
}

function adjustPadding(container, img) {
    if (!img.naturalWidth || !img.naturalHeight) return;

    const imageWidth = img.naturalWidth;
    const imageHeight = img.naturalHeight;
    const containerWidth = container.offsetWidth;

    let paddingTop = (imageHeight / imageWidth) * containerWidth;

    // Based on the Crop on the images
    const maxPadding = window.innerWidth > 767 ? 910 : 575;
    paddingTop = Math.min(paddingTop, maxPadding);

    container.style.paddingTop = `${paddingTop}px`;
}

document.addEventListener("readystatechange", () => {
    if (document.readyState === "complete") {
        updatePadding();
    }
});

window.addEventListener("load", updatePadding);
window.addEventListener("resize", updatePadding);

const observer = new MutationObserver(updatePadding);
observer.observe(document.body, { childList: true, subtree: true });

// Sometimes it didnt work 100% so I added an observer to see if its in view
const intersectionObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            updatePadding();
        }
    });
});
document.querySelectorAll(".image-container img").forEach(img => intersectionObserver.observe(img));
